<template>
<div>
    <b-container>

        
        <b-row>
        
        <!-- Submitting order transition -->
        <transition name="fade">
            <div v-if="performingRequest" class="loading">
                <p>Submitting your order...</p>
            </div>
        </transition>

        <!-- Checking coupon transition-->
        <transition name="fade">
            <div v-if="showCheckingCoupon" class="loading">
                <p>Checking Coupon...</p>
            </div>
        </transition>

        <div>
            <b-modal no-fade  size="l" id="modal-quantityexceedscart" ok-only title="Error" ok-title="OK">
                {{quantityerrormessage}}   
            </b-modal>
        </div>
        
        <!-- Modal coupon message -->
        <b-modal no-fade  size="l" id="modal-couponerror" ok-only :title="couponErrorTitle" ok-title="OK">
                {{couponErrorMessage}}  
        </b-modal>

        <div>
            <!-- Modal to ask for ABC license number -->
            <b-modal no-fade  size="l" id="modal-noabclicense" ok-only title="Missing ABC License Number" @ok="submitLicense()" ok-title="OK">
                Please enter your ABC license number to order beers
                <input v-model="abcLicenseNumber" type="text" id="abclicense">
            </b-modal>

            <!-- Modal to ask for phone number -->
            <b-modal no-fade  size="l" id="modal-nophone" ok-only title="Missing Phone Number" @ok="submitPhone()" ok-title="OK">
                Please enter your phone number to place order
                <!-- Phone Number -->
                <b-form-group
                id="fieldset-6"
                label="Phone (required)"
                label-for="input-7"
                :invalid-feedback="invalidPhone"
                :state="checkPhoneValid"
                >
                    <b-form-input   id="input-7" v-model="newBuyerPhone" trim></b-form-input>
                </b-form-group>
            </b-modal>

            <!-- Modal to add new address -->
            <b-modal no-fade  size="l" id="modal-newaddress" title="Enter a new address" @ok="addNewAddress()" ok-title="Add">
                Enter New Address
                <b-input-group prepend="Street1" class="mt-3">
                    <b-form-input v-model="newAddress.street1" ></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group prepend="Street2" class="mt-3">
                    <b-form-input v-model="newAddress.street2" ></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group prepend="City" class="mt-3">
                    <b-form-input v-model="newAddress.city" ></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group prepend="State" class="mt-3">
                    <b-form-input v-model="newAddress.state" ></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
                <b-input-group prepend="zip" class="mt-3">
                    <b-form-input v-model="newAddress.zip" ></b-form-input>
                    <b-input-group-append>
                    </b-input-group-append>
                </b-input-group>
            </b-modal>

        </div>

        <!-- Order placed message -->
        <div class = "col1" v-if = showOrdersPlaced>
            <h4> Your order has been placed. We will update you when the brewery accepts your order </h4>
        </div>
        </b-row>
        <b-row>
        <div class="col1" v-if ="!getCartSize">
            <br>
            <br>
            <h5>Nothing in your cart yet. Go to <router-link to="allbeers" >FIND BEERS</router-link> to add some beers to your cart</h5>

        </div>
        </b-row>

        <b-row style="margin-top:20px; margin-left:20px" v-if ="getCartSize">
            <h4>Shopping Cart</h4>
        </b-row>

        <!-- Cards of orders -->
        <b-card v-for="(item) in userCart" :key="item.suborderid">
            <b-container>
                <b-row >
                    <!-- Image -->
                    <b-col cols="2">
                        <div v-if="item.beerLogoURL" style="width:50px; text-align: center">
                            <img :src="item.beerLogoURL" width="50" fluid alt="Logo image"
                            >
                        </div>
                        <div v-else style="height:75px; text-align: center">
                            <img src="https://res.cloudinary.com/lo4xxr5lr/image/upload/v1574513408/stock/beer.jpg" height="75" fluid alt="Logo image">
                        </div>
                    </b-col>
                    <!-- Other info -->
                    <b-col>
                        <b-container>
                            <b-row>
                                <b-col>
                                    <div class="breweryname" style="margin-right:50px"><h5>{{item.brewer}}</h5></div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div  style="margin-right:50px"><h5>{{item.beerName}}</h5></div>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col>
                                    <div  style="margin-right:50px">{{item.size}}</div>
                                </b-col>
                            </b-row>
                        </b-container>
                    </b-col>
                </b-row>
                <!-- Quantity updates and cost -->
                <b-row style="margin-top:20px">
                    <b-col cols='3'>
                        <div style="color:green; font-size:20px">${{item.cost}}</div>
                    </b-col>
                    <b-col>
                        <b-button-group  style="border-width:1px; border-color:#bfbfbf; border-style:solid; border-radius:5px">
                            <b-button  variant="transparent"><font-awesome-icon icon="minus"  @click="updateQuantity(item.id, item.orderQuantity-1, item)"/></b-button>
                            <div style="width:50px; text-align:center; border-width:2px; border-color:#000; margin-top:5px"> {{item.orderQuantity}}</div>
                            <b-button variant="transparent"><font-awesome-icon icon="plus"  @click="updateQuantity(item.id, item.orderQuantity+1, item)"/></b-button>
                            <b-button  variant="danger" v-b-modal="'delete' + item.suborderid">Delete</b-button>
                        </b-button-group>
                    </b-col>
                </b-row>
                <!-- Delete modal -->
                <b-modal
                    :id="'delete' + item.suborderid" title="Delete"  ok-title="Delete" cancel-title='No, Do not delete' @ok="deleteItem(item.suborderid)" >
                    Delete {{item.beerName}} from cart?
                </b-modal>
            </b-container>
        </b-card>

        <!-- Total cart cost -->
        <b-row v-if ="getCartSize" style="margin-top:10px">
            <b-col>
                <h6> Total Cost:<span style="color:green"> ${{getCartCost}}</span></h6>
            </b-col>
        </b-row>
        <hr>

        <!-- User address -->
        <b-row>
            <b-col>
                <h6> Shipping Address</h6>
            </b-col>
        </b-row>
        
        <!-- Default address -->
        <b-row>
            <b-card :bg-variant="defaultAddressVariant" style="cursor:pointer; font-size:14px; margin-left:10px; margin-top:5px" @click="chooseAnotherAddress(userProfile.street1, userProfile.street2,userProfile.city, userProfile.state,  userProfile.zip, 0, 1)">
                <div style="color:white">{{userProfile.street1}}</div>
                <div v-if="userProfile.street2" style="color:white">{{userProfile.street2}}</div>
                <div style="color:white">{{userProfile.city}}, {{userProfile.state}} {{userProfile.zip}}</div>
                <div></div>
            </b-card>
            <!-- Other addresses -->
            <template v-for="(address, index) in userProfile.otherAddresses" >
            <b-card :key="address.address.street1" :bg-variant="selectedAddressIndexVariant[index]" style="cursor:pointer; font-size:12px; margin-left:10px; margin-top:5px" @click="chooseAnotherAddress(address.address.street1, address.address.street2,address.address.city, address.address.state,  address.address.zip, index, 0)">
                <div>{{address.address.street1}}</div>
                <div v-if="address.address.street2">{{address.address.street2}}</div>
                <div>{{address.address.city}}, {{address.address.state}} {{address.address.zip}}</div>
                <div></div>
            </b-card>
            </template>
            <b-card v-b-modal.modal-newaddress style="cursor: pointer; font-size:12px; background-color:#f0ad4e; color:white; margin-left:10px; margin-top:5px"> 
                <div style="text-align:center"> <h4>+</h4> </div>
                Add Another Address
            </b-card>
    
        </b-row>

        <!-- Delivery date -->
        <b-row v-if ="getCartSize">
            <b-col>
                <hr>
                <div  style="width:500px; color:green">
                <b-form-group
                    id="fieldset-19"
                    label="(Optional) Request a delivery date"
                    label-for="input-date"
                    description="Minimum 2 days required for delivery. No delivery on weekends."
                    >
                    <b-form-datepicker size="sm" value-as-date id="example-datepicker"  :date-disabled-fn="dateDisabled" :min="minDate" v-model="desiredDate" ></b-form-datepicker>
                </b-form-group>
                </div>
            </b-col>
        </b-row>

        <!-- Notes -->
        <b-row v-if ="getCartSize">
            <b-col>
                <div style="color:green">
                    (Optional) Add a note to sellers
                </div>
                <b-form-textarea id="textarea-formatter" v-model="buyerNote" placeholder="Note to sellers"></b-form-textarea>
            </b-col>
        </b-row>

        <!-- Request services -->
        <b-row  v-if ="getCartSize" style="margin-top:2px; color:green">
            <b-col>
                (Optional) Request Services
            </b-col>
        </b-row>
        <b-row v-if ="getCartSize">
            <b-col>
                <b-button variant="info" v-b-modal.modal-servicerequest>Request Services</b-button>
            </b-col>
        </b-row>
        <b-row v-if ="getCartSize">
            <b-col>
                <small><i>Line cleaning, tap handles, keg pickup, signage</i></small>
            </b-col>
        </b-row>
        <b-modal id="modal-servicerequest" title="Create Service Requests" size="xl" hide-footer
            header-bg-variant="info" header-text-variant="light">
            <servicerequests :brewersLists='getBrewersList' @closeServicesModal="closeServicesModal" />
        </b-modal>

        <!-- Coupons -->
        <b-row v-if ="allowCoupons&&getCartSize" style="margin-top:10px">
            <b-col>
                <small>Enter a coupon if you have one, and press "Apply Coupon"</small>
                <b-input-group  size="sm" prepend="Coupon Number">
                    <b-form-input size="sm" v-model="couponId" ></b-form-input>
                    <b-input-group-append size="sm" ><b-button size="sm" :disabled="!couponId" variant="success" @click="applyCoupon()">Apply Coupon</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-col>
        </b-row>
        <b-row v-if="couponValid&&allowCoupons"><b-col style="color:green"><small><i>This coupon for ${{theCoupon.value}} {{theCoupon.type}} has been applied</i></small></b-col></b-row>

        <!-- Confirm order button -->
        <b-row v-if ="getCartSize" style="margin-top:10px">
            <b-col>
                    <b-button v-b-modal.modal-submit variant='success'>PLACE ORDER</b-button>
                    <b-modal  no-fade  scrollable size="l" id="modal-submit" title="Confirm Order" @ok="submitOrder()">
                        <h4>Confirm Order For:</h4>
                        <div v-for="(item) in userCart" :key="item.id+item.beerName+item.size">
                            <strong>{{item.orderQuantity}} {{item.beerName}}</strong>
                        </div>
                    </b-modal>
            </b-col>
        </b-row>

        <b-row style="margin-top:10px">
            <b-col>
                <b-button variant='outline-success' @click="continueShopping">CONTINUE SHOPPING</b-button>
            </b-col>
        </b-row>
    </b-container>
    <footer><pagefooter/></footer>
    </div>
</template>

<script>

    import { mapState } from 'vuex'
    import moment from 'moment'
    import { currentUser } from '../firebaseConfig'
    const fb = require('../firebaseConfig.js')
    import firebase from 'firebase/app';
    import {incrementbeerinventory} from './Myfunctions'
    const db = firebase.firestore()
    import axios from 'axios'
    import Pagefooter from './Pagefooter'
    import {sendnotification} from './Myfunctions'
    import Servicerequests from './buyer/Servicerequests'

    export default {
        components: {
            Pagefooter,
            Servicerequests,
        },

        data() {
            return {
                beer:'',
                totalCartCost:0,
                orderedNumber:0,
                performingRequest:false,
                inventoryChanged:false,
                showOrdersPlaced:false,
                quantityerrormessage:'',
                buyerNote:'',
                desiredDate:'',
                abcLicenseNumber:'',
                licenseNumberValid:false,
                shippingAddress:{},
                defaultAddressSelected: true,
                selectedAddress:'',
                selectedAddressIndexVariant:[],
                newBuyerPhone:"",
                newAddress:{
                    street1:'',
                    street2:'',
                    city:'',
                    zip:'',
                    state:'',
                },
                minDate:"",
                couponId:"",
                couponErrorMessage:"",
                couponErrorTitle:"",
                showCheckingCoupon:false,
                couponValid:false,
                theCoupon:{},

                }
        },

        computed: {
            ...mapState(['userProfile', 'currentUser', 'userCart', 'everyAvailableBeer', 'allowCoupons']),
            getCartCost: function () {
                var totalCost = 0
                for (var i in this.userCart){
                    var quantity = parseInt(this.userCart[i].orderQuantity)
                    var cost = parseInt(this.userCart[i].cost)
                    totalCost = totalCost + quantity*cost

                }
                this.totalCartCost = totalCost
            return this.totalCartCost
            },
            getCartSize(){
                return this.userCart.length
            },
            defaultAddressVariant(){
                if(this.defaultAddressSelected){
                    return "info"
                } 
                else{
                    return "light"
                } 

            },

            //Window size
            getWindowWidth(){
                return window.innerWidth;
            },

            //Brewerslist for services
            getBrewersList(){
                var brewersList = []
                for (var i=0; i<this.userCart.length; i++){
                    var thisBrewer = {}
                    var thisCartItem = this.userCart[i]
                    thisBrewer.company = thisCartItem.brewer
                    thisBrewer.brewerid = thisCartItem.uid
                    brewersList.push(thisBrewer)
                }
                return brewersList
            },

            //Check phone valid
            checkPhoneValid(){

                 if (/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(this.newBuyerPhone))
                    {
                        return (true)
                    }
                        return (false)
            },
            //Invalid phone feedback
            invalidPhone(){
                if (this.checkPhoneValid) 
                    return ''
                else 
                    return 'Please check the phone number'
            },
        },
        watch: {
            userCart(newValue, oldValue) {
            },
        },
        methods: {
            deleteItem(suborderid) {
                this.$store.commit('deleteItemFromCart', suborderid)
            },
            submitLicense(){
                if (this.abcLicenseNumber.length >3 ){
                    var isnum = /^\d+$/.test(this.abcLicenseNumber);
                    if(isnum){
                        //Update license number
                        fb.usersCollection.doc(this.currentUser.uid).update({
                            abcLicenseNumber: this.abcLicenseNumber,
                            
                        })
                        this.licenseNumberValid=true
                        this.submitOrder()
                    } 
                    else {
                        this.$bvToast.toast('Invalid ABC License number', {
                        title: 'Please double check the license number',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 10000,
                        appendToast: false
                        })
                    }
                } 
                else {
                        this.$bvToast.toast('Invalid ABC License number', {
                        title: 'Please double check the license number',
                        solid:true,
                        variant: 'danger',
                        autoHideDelay: 10000,
                        appendToast: false
                        })

                }

            },

            submitPhone(){
                if (/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(this.newBuyerPhone)){
                    //Update phone number
                    fb.usersCollection.doc(this.currentUser.uid).update({
                        phone: this.newBuyerPhone,
                        
                    })
                    this.submitOrder()
                }
                else {
                    this.$bvToast.toast('Invalid Phone number', {
                    title: 'Please double check the phone number',
                    solid:true,
                    variant: 'danger',
                    autoHideDelay: 10000,
                    appendToast: false
                    })
                }


            },

            updateQuantity(beerId,quantity, beerObject) {
                if (parseInt(quantity)<1) {
                    console.log("Qty <1")
                    this.$bvModal.show('delete'+beerObject.suborderid)
                    //this.$store.commit('deleteItemFromCart', beerObject.suborderid)
                    return
                }
                let toupdate = {}
                toupdate.id=beerId
                toupdate.suborderid = beerObject.suborderid
                toupdate.orderQuantity=parseInt(quantity)
                toupdate.available = parseInt(beerObject.available)

                if(toupdate.orderQuantity>toupdate.available){
                    this.quantityerrormessage = 'Sorry, there are only ' + toupdate.available +' available. Your cart quantity has been updated to ' + toupdate.available
                    this.$bvModal.show("modal-quantityexceedscart")
                    toupdate.orderQuantity = beerObject.available
                }
                
                this.$store.commit('updateQuantityInCart', toupdate)
                this.$bvToast.toast('Quantity in you cart has been updated', {
                        title: 'Cart Updated',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 10000,
                        appendToast: false
                        })
            },
            addNewAddress(){

                if(this.newAddress.street1.length<5){
                    this.$bvToast.toast('Please check street1', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })
                        return
                }

                if(this.newAddress.city.length<3){
                    this.$bvToast.toast('Please check city', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })
                        return
                }
                if(this.newAddress.state.length<2){
                    this.$bvToast.toast('Please check state', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })
                        return
                }

                if (/^[0-9]{5}(?:-[0-9]{4})?$/.test(this.newAddress.zip))
                {

                }
                else {
                    this.$bvToast.toast('Please check zip code', {
                        title: 'Keg Seeker',
                        autoHideDelay: 2000,
                        appendToast: false,
                        solid:true,
                        variant:'warning',
                        })
                        return
                }

                var addressObject = {}
                addressObject.street1 = this.newAddress.street1
                if(this.newAddress.street2) addressObject.street2 = this.newAddress.street2
                addressObject.city = this.newAddress.city
                addressObject.state = this.newAddress.state
                addressObject.zip = this.newAddress.zip

                fb.usersCollection.doc(this.currentUser.uid).update({
                    otherAddresses: firebase.firestore.FieldValue.arrayUnion({address: addressObject})
                    }).then((response) => {
                        this.performingRequest = false
                        this.showMessageSent = true
                        setTimeout(() => { this.showMessageSent = false }, 1500)
                        this.theMessage = ''
                            })

            },

            chooseAnotherAddress(street1, street2, city, state, zip, index, defaultSelected){
                if(defaultSelected){
                    this.defaultAddressSelected = true
                } 
                else this.defaultAddressSelected = false

                this.selectedAddressIndexVariant = []

                for (var i=0; i<this.userProfile.otherAddresses.length; i++){
                    this.selectedAddressIndexVariant[i] ="light"
                    if (i==index&&!defaultSelected) this.selectedAddressIndexVariant[i] ="info"
                }

                console.log(street1, street2,city, state, zip )
                
                this.selectedAddress = street1
                if(street2) this.selectedAddress = this.selectedAddress  + ' ' +street2
                this.selectedAddress = this.selectedAddress  + ', '  + city + ', ' + state + ' ' + zip

            },

            //Disable weekend delivery selection
            dateDisabled(ymd, date) {
                // Disable weekends (Sunday = `0`, Saturday = `6`) and
                // disable days that fall on the 13th of the month
                const weekday = date.getDay()
                const day = date.getDate()
                // Return `true` if the date should be disabled
                return weekday === 0 || weekday === 6 
            },

            submitOrder(){
                console.log("Submitting order")
                //Ask for ABC license number for retailers
                if(!this.userProfile.abcLicenseNumber&&!this.licenseNumberValid&&(this.userProfile.isbrewer==0)){
                    this.$bvModal.show("modal-noabclicense")
                    return
                }

                //Ask for phone number
                if(!this.userProfile.phone){
                    //Check if new phone already added
                    if(/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/.test(this.newBuyerPhone)){

                    }
                    else{
                        this.$bvModal.show("modal-nophone")
                        return
                    } 
                }

                var address

                //User did not change default address
                if (this.defaultAddressSelected){
                    address = this.userProfile.street1
                    if(this.userProfile.street2) address = address + ', ' + this.userProfile.street2
                    address = address + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip
                }
                else address = this.selectedAddress
                //User selected a different address

                //If no address, just put default address
                if (address.length < 10){
                    address = this.userProfile.street1
                    if(this.userProfile.street2) address = address + ', ' + this.userProfile.street2
                    address = address + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip
                }

                //Get billing address
                var billingaddress = this.userProfile.street1
                if(this.userProfile.street2) billingaddress = billingaddress + ', ' + this.userProfile.street2
                billingaddress = billingaddress + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip

                
                this.orderedNumber = 0
                var lengthOfOrders = this.userCart.length
                var randomIdString1 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

                for (var i in this.userCart){
                    //Check available quanity and update if needed
                    var lengthAllBeers = this.everyAvailableBeer.length
                    for (var j=0; j<lengthAllBeers; j++){
                        var thisBeer = this.everyAvailableBeer[j]
                        if (this.desiredDate) thisBeer.desiredDate = this.desiredDate
                    }

                    var delMethod=""

                    if(this.userCart[i].deliveryMethod) delMethod = this.userCart[i].deliveryMethod

                    var randomIdString2 = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)

                    var multiSize = 0
                    if (this.userCart[i].multiSize == 1) multiSize =1

                    var buyerPhone=""
                    if(this.userProfile.phone) buyerPhone=this.userProfile.phone
                    else if (this.newBuyerPhone) buyerPhone=this.newBuyerPhone

                    var theOrder = {
                                createdOn: new Date(),
                                buyerEmail:this.userProfile.email,
                                buyerPhone: buyerPhone,
                                multiSize: multiSize,
                                beerName: this.userCart[i].beerName,
                                deliveryMethod: delMethod,
                                cost: this.userCart[i].cost,
                                orderQuantity: this.userCart[i].orderQuantity,
                                pubid:this.currentUser.uid,
                                brewerid:this.userCart[i].uid,
                                quantity:this.userCart[i].orderQuantity,
                                mainorderid:randomIdString1,
                                suborderid:randomIdString2,
                                brewer:this.userCart[i].brewer,
                                pub:this.userProfile.company,
                                beerId:this.userCart[i].docId,
                                totalCost:parseFloat(this.userCart[i].cost)*parseFloat(this.userCart[i].orderQuantity),
                                size:this.userCart[i].size,
                                container:this.userCart[i].container,
                                type:this.userCart[i].type,
                                status:0,
                                deliveryAddress: address,
                                billingAddress:billingaddress,
                                docId:this.userCart[i].docId,
                                buyerNote: this.buyerNote,
                                deliveryDate: this.desiredDate,
                                desiredDate: this.desiredDate,
                                fromapp:0,
                                county:this.userProfile.county,
                         }
                         //Add coupon ID to order
                         if(this.theCoupon&&this.theCoupon.couponId&&this.couponValid){
                             theOrder.coupon=this.theCoupon
                         }

                        fb.ordersCollection.add(theOrder)

                            //Decrease inventory
                            var brewerId = theOrder.brewerid
                            var qty = -1*parseInt(theOrder.orderQuantity)
                            incrementbeerinventory(this.userCart[i].docId, qty, this.userCart[i])
                            //Update brewer orders count
                            var incrementOrders = firebase.firestore.FieldValue.increment(1);
                            //Disable write to seller's profile. This could have security issues. Permission will not be given on FB.
                            //fb.usersCollection.doc(brewerId).update({ ordersCount: incrementOrders })
                            var incrementBeersSold = firebase.firestore.FieldValue.increment(parseInt(theOrder.orderQuantity));
                            fb.beersCollection.doc(theOrder.docId).update({ soldCount: incrementBeersSold })

                            // Add to news feed
                            var feedString
                            var feedObject = {}
                            feedObject.brewerId = brewerId
                            feedObject.pubId = this.currentUser.uid
                            feedString = this.userProfile.company + ' ordered ' + this.userCart[i].orderQuantity.toString() + ' ' + this.userCart[i].beerName +', waiting for '+this.userCart[i].brewer+' to accept the order'
                            feedObject.feedString = feedString
                            this.$store.dispatch('addToNewsFeed',feedObject)

                            //Send email to brewer
                            var subject = 'New order from ' + this.userProfile.company
                            var text = this.userProfile.company + ' ordered ' + theOrder.orderQuantity.toString() + ' ' + this.userCart[i].beerName

                            //Send email to pub
                            text ='Order received for ' + theOrder.orderQuantity.toString() + ' ' + this.userCart[i].beerName +'. We will update you when ' + this.userCart[i].brewer + ' accepts your order'
                            subject = 'New order for ' + this.userCart[i].beerName
                            
                            //Fire notification
                            //sendnotification(this.userCart[i].uid, feedString)

                }
                //Update coupons collection to make this coupon used
                if(this.theCoupon&&this.theCoupon.couponId&&this.couponValid){
                    //Get billing address
                    var billingaddress = this.userProfile.street1
                    if(this.userProfile.street2) billingaddress = billingaddress + ', ' + this.userProfile.street2
                    billingaddress = billingaddress + ', ' + this.userProfile.city + ', ' + this.userProfile.state + ', ' + this.userProfile.zip

                    fb.couponsCollection.doc(this.theCoupon.docId).update({used:1, usedByEmail:this.currentUser.email, usedByName:this.userProfile.company,
                    suborderid:randomIdString2, usedOn:new Date(), usedByAddress:billingaddress})
                }
                this.showOrdersPlaced = true
                this.$store.commit('emptyCart', '')
                this.totalCartCost = 0
                this.performingRequest=false
                this.$bvToast.toast('All Orders Placed. Check the orders page for updates', {
                        title: 'Keg Seeker',
                        solid:true,
                        variant: 'success',
                        autoHideDelay: 5000,
                        appendToast: false
                        })
                setTimeout(() => { this.showOrdersPlaced = false }, 15000)
            },
            continueShopping(){
                this.$router.push({ name: 'allbeers'})

            },

            //Quantity changed
            quantityChanged(){
                console.log("Quantity changed")
            },

            //Close services modal
            closeServicesModal(){
                this.$bvModal.hide("modal-servicerequest")
            },

            //Apply a coupon
            applyCoupon(){
                //Check coupon validity
                this.showCheckingCoupon=true
                //Get the coupon
                var couponData
                fb.couponsCollection.where('couponId', '==', this.couponId).get().then(docs => {
                    docs.forEach(doc => {
                        couponData = doc.data()
                        couponData.docId=doc.id
                    })
                }).then(res => {
                    this.showCheckingCoupon=false
                    const d = new Date();
                    var nowTime = d.getTime();

                    //Invalid coupon ID
                    if(!couponData){
                        console.log("No such coupon")
                        this.theCoupon=null
                        this.couponValid=false
                        this.couponId=""
                        this.couponErrorTitle="Coupon Error"
                        this.couponErrorMessage="This seems to be an invalid coupon. Please check the ID you entered. The ID is case sensitive."
                        this.$bvModal.show("modal-couponerror")
                    } 
                    //Used coupon ID
                    else if(couponData.used==1){
                        console.log("Coupon Used")
                        this.couponValid=false
                        this.theCoupon=null
                        this.couponId=""
                        this.couponErrorTitle="Coupon Used"
                        this.couponErrorMessage="This coupon has already been used."
                        this.$bvModal.show("modal-couponerror")
                    }
                    //Check if expired
                    else if(nowTime>couponData.expiresOn.seconds*1000){
                        console.log("Coupon expired")
                        this.couponValid=false
                        this.theCoupon=null
                        this.couponId=""
                        this.couponErrorTitle="Coupon Expired"
                        this.couponErrorMessage="This coupon has expired."
                        this.$bvModal.show("modal-couponerror")
                    }

                    //Check minimum order
                    else if (this.getCartCost<parseInt(couponData.minOrder)){
                        console.log("Min order not met")
                        this.couponValid=false
                        this.theCoupon=null
                        this.couponId=""
                        this.couponErrorTitle="Coupon Error"
                        this.couponErrorMessage="You must order at least $" + couponData.minOrder +' to use this coupon'
                        this.$bvModal.show("modal-couponerror")

                    }

                    //Coupon is good
                    else{
                        this.theCoupon=couponData
                        this.couponErrorTitle="Coupon Applied"
                        this.couponValid=true
                        this.couponErrorMessage=couponData.description
                        this.$bvModal.show("modal-couponerror")
                    }
                })

            },
        },
        mounted(){
            //Set min date to two days
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            const theminDate = new Date(today)
            theminDate.setDate(theminDate.getDate() + 2)
            this.minDate=theminDate
        }
        
    }
</script>
<style scoped>
.active {
  background: green;
}
.inactive {
  background: whitesmoke;
}
.address{
    font-size:15px;
}
</style>